import React from "react";
import { Components, Form } from "@formio/react";
import components from "./Custom";
import axios from 'axios';
import toastr from 'reactjs-toastr';
import $ from 'jquery';

Components.setComponents(components);

class RenderFormBuilder extends React.Component {

  submitFormData (schema) {
    validateForm("false");
    let activeTab = $('div.tab-pane-full.active');
    let activeForm = activeTab.find('form.autosave-form');
    var data = schema.data

     if (data.drugAllergiesComp){
        data.drugAllergiesComp.widget_data = []
      }
      if (data.nonDrugAllergiesComp){
        data.nonDrugAllergiesComp.widget_data = []
      }
      if (data.medicalDiagnosisComp){
        data.medicalDiagnosisComp.widget_data = []
      }

      if (data.vitalSignsComp){
        data.vitalSignsComp.widget_data = []
      }

      if (data.immunizationComp){
        data.immunizationComp.widget_data = []
      }

      if (data.udiComp){
        data.udiComp.widget_data = []
      }

      if (data.proceduresComp){
        data.proceduresComp.widget_data = []
      }
      if (data.psychDiagnosisComp){
        data.psychDiagnosisComp.widget_data = []
      }

      if (data.medicationListComp){
        data.medicationListComp.widget_data = []
      }

      if (data.labsComp){
        data.labsComp.widget_data = []
      }


    if (schema && schema.changed && schema.changed.flags && schema.changed.flags.fromSubmission == undefined){
      axios.post(`/submission?id=${this.props.form_builder.guid}&patient_guid=${this.props.patient_guid}&patient_form_guid=${this.props.patient_form_guid}`, {data: schema.data})
      .then(res => {
        activeForm.parent().parent().attr('data-saved-id', res.data.patient_form_id);

        $('#copy-note-container .form-version-bubbles').removeClass('isDisabled');
        $('#copy-note-container span#no-prior-note').hide();
        $('.no-prior-note').show();
        $('#patient_note_name').html(res.data.form_name)
        $('#copy-note-container span.note_updated_at').html(res.data.updated_at);

        // toastr.success('Data is saved')

      }).catch(error => {
        toastr.error('Error')
      })
    }
  }

  render () {
    var form_json_data = JSON.parse(this.props.form_builder.content);
    var form_builder_data = {};
    if (this.props.form_builder_data) {
      form_builder_data = this.props.form_builder_data.value;
    } else if (this.props.last_form_saved_data) {
      form_builder_data = this.props.last_form_saved_data;
    }

    return (
      <div>
        <Form
        	form={form_json_data}
        	submission={{data: form_builder_data}}
          onChange={(schema) => this.submitFormData(schema)}
        	// onSubmit={console.log}
      	/>
      </div>
    );
  }
}

RenderFormBuilder.propTypes = {
};

export default RenderFormBuilder
